module.exports = __webpack_public_path__ + "img/header-hotel-prince-park-.82f59775.jpg";